var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar11(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_50_Kids_Icons-44",
    "data-name": "50_Kids_Icons-44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1564",
    "data-name": "Path 1564",
    d: "M0,40A40,40,0,1,1,40,80,40,40,0,0,1,0,40Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1561",
    "data-name": "Path 1561",
    d: "M0,40A40,40,0,1,1,40,80,40,40,0,0,1,0,40Z",
    fill: "#3d2a3d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4879",
    "data-name": "Group 4879"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4861",
    "data-name": "Group 4861",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1562",
    "data-name": "Path 1562",
    d: "M152.947,242.493c1.025,2.428.467,4.787-1.247,5.27s-3.933-1.093-4.958-3.521-.467-4.787,1.247-5.27S151.922,240.065,152.947,242.493Z",
    transform: "translate(-123.38 -201.559)",
    fill: "#e38a5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1563",
    "data-name": "Path 1563",
    d: "M320,242.492c-1.025,2.428-.467,4.787,1.247,5.27s3.933-1.093,4.958-3.521.467-4.787-1.247-5.27S321.025,240.065,320,242.492Z",
    transform: "translate(-269.567 -201.559)",
    fill: "#e38a5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4862",
    "data-name": "Group 4862",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1565",
    "data-name": "Path 1565",
    d: "M128.4,408.258l-.008-.132c0-8-2.995-15.753-6.652-17.229l-15.575-6.275a20.633,20.633,0,0,0-13.3-.017l-15.8,6.312c-3.66,1.465-6.655,9.208-6.655,17.209l-.008.132Z",
    transform: "translate(-59.397 -323.589)",
    fill: "#e38a5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4863",
    "data-name": "Group 4863",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1567",
    "data-name": "Path 1567",
    d: "M226.979,273.007a6.219,6.219,0,0,1-6.219,6.219h-.754a6.219,6.219,0,0,1-6.219-6.219V256.989a6.219,6.219,0,0,1,6.219-6.219h.754a6.219,6.219,0,0,1,6.219,6.219Z",
    transform: "translate(-180.384 -211.587)",
    fill: "#e38a5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4865",
    "data-name": "Group 4865",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4864",
    "data-name": "Group 4864",
    transform: "translate(26.617 17.482)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1569",
    "data-name": "Path 1569",
    d: "M197.113,139.36a10.422,10.422,0,0,1-10.423,10.422h-5.923a10.422,10.422,0,0,1-10.422-10.422V122.306a10.422,10.422,0,0,1,10.422-10.422h5.923a10.422,10.422,0,0,1,10.423,10.422Z",
    transform: "translate(-170.346 -111.884)",
    fill: "#f5b68c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4866",
    "data-name": "Group 4866",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_287",
    "data-name": "Ellipse 287",
    cx: 1.548,
    cy: 1.548,
    r: 1.548,
    transform: "translate(33.321 39.387)",
    fill: "#4a87a3"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_288",
    "data-name": "Ellipse 288",
    cx: 1.548,
    cy: 1.548,
    r: 1.548,
    transform: "translate(43.584 39.387)",
    fill: "#4a87a3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4867",
    "data-name": "Group 4867",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1572",
    "data-name": "Path 1572",
    d: "M171.161,98.076c-8.677,0-15.711,7.624-15.711,17.029a18.05,18.05,0,0,0,2.13,8.566l.368-3.117a11.464,11.464,0,0,1,11.385-10.122h3.655a11.464,11.464,0,0,1,11.386,10.12l.368,3.119a18.051,18.051,0,0,0,2.13-8.566C186.872,105.7,179.838,98.076,171.161,98.076Z",
    transform: "translate(-131.161 -82.752)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4868",
    "data-name": "Group 4868",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1574",
    "data-name": "Path 1574",
    d: "M244.43,275.542a2.384,2.384,0,0,1-4.653.538,2.526,2.526,0,0,0-.114.71,2.553,2.553,0,1,0,5.105,0A2.516,2.516,0,0,0,244.43,275.542Z",
    transform: "translate(-202.216 -232.489)",
    fill: "#e38a5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4869",
    "data-name": "Group 4869",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1576",
    "data-name": "Path 1576",
    d: "M128.39,421.067c0-8-3-15.753-6.652-17.229l-12.384-4.989a10.937,10.937,0,0,1-19.889.053l-12.4,4.956c-3.66,1.465-6.655,9.208-6.655,17.209l-.008.132h58Z",
    transform: "translate(-59.398 -336.529)",
    fill: "#d12c2c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4871",
    "data-name": "Group 4871",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4870",
    "data-name": "Group 4870",
    transform: "translate(34.627 47.953)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1578",
    "data-name": "Path 1578",
    d: "M221.616,306.9c0,.029,0,.062,0,.092a5.373,5.373,0,1,0,10.746,0c0-.031,0-.064,0-.092Z",
    transform: "translate(-221.614 -306.902)",
    fill: "#a91935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1579",
    "data-name": "Path 1579",
    d: "M232.542,306.9v.46a1.687,1.687,0,0,0,1.687,1.688h5.527a1.688,1.688,0,0,0,1.689-1.688v-.46Z",
    transform: "translate(-230.835 -306.902)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4872",
    "data-name": "Group 4872",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_289",
    "data-name": "Ellipse 289",
    cx: 3.125,
    cy: 2.344,
    rx: 3.125,
    ry: 2.344,
    transform: "translate(45.469 42.482)",
    fill: "#eb987f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_290",
    "data-name": "Ellipse 290",
    cx: 3.125,
    cy: 2.344,
    rx: 3.125,
    ry: 2.344,
    transform: "translate(28.281 42.482)",
    fill: "#eb987f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4875",
    "data-name": "Group 4875",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4873",
    "data-name": "Group 4873",
    transform: "translate(31.738 37.061)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1582",
    "data-name": "Path 1582",
    d: "M204.312,239.3a2.882,2.882,0,0,1,2.748-.626.686.686,0,0,0,.365-1.322,4.3,4.3,0,0,0-4.082.978c-.656.6.317,1.563.97.97Z",
    transform: "translate(-203.124 -237.192)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4874",
    "data-name": "Group 4874",
    transform: "translate(43.477 37.061)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1583",
    "data-name": "Path 1583",
    d: "M282.821,238.333a4.3,4.3,0,0,0-4.082-.978.686.686,0,0,0,.365,1.322,2.882,2.882,0,0,1,2.748.626c.653.593,1.626-.374.97-.97Z",
    transform: "translate(-278.255 -237.192)",
    fill: "#fceeb3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4876",
    "data-name": "Group 4876",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1585",
    "data-name": "Path 1585",
    d: "M47.835,140.667a24.533,24.533,0,0,1,14.157-22.234,18.751,18.751,0,1,0-10.44,35.218A24.413,24.413,0,0,1,47.835,140.667Z",
    transform: "translate(-29.023 -98.06)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1586",
    "data-name": "Path 1586",
    d: "M315.157,140.667A24.533,24.533,0,0,0,301,118.433a18.751,18.751,0,1,1,10.44,35.218A24.413,24.413,0,0,0,315.157,140.667Z",
    transform: "translate(-253.969 -98.06)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4877",
    "data-name": "Group 4877",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1588",
    "data-name": "Path 1588",
    d: "M165.246,115.487h0a2.344,2.344,0,0,1-.979-3.167l1.458-2.764a2.344,2.344,0,0,1,3.167-.979h0a2.344,2.344,0,0,1,.979,3.167l-1.458,2.764A2.344,2.344,0,0,1,165.246,115.487Z",
    transform: "translate(-138.371 -91.383)",
    fill: "#d12c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1589",
    "data-name": "Path 1589",
    d: "M313.562,115.487h0a2.344,2.344,0,0,0,.979-3.167l-1.458-2.764a2.344,2.344,0,0,0-3.167-.979h0a2.344,2.344,0,0,0-.979,3.167l1.458,2.764A2.344,2.344,0,0,0,313.562,115.487Z",
    transform: "translate(-260.437 -91.383)",
    fill: "#d12c2c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4878",
    "data-name": "Group 4878",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_291",
    "data-name": "Ellipse 291",
    cx: 5.469,
    cy: 3.906,
    rx: 5.469,
    ry: 3.906,
    transform: "translate(29.063 24.375)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_292",
    "data-name": "Ellipse 292",
    cx: 5.469,
    cy: 3.906,
    rx: 5.469,
    ry: 3.906,
    transform: "translate(40 24.375)",
    fill: "#fceeb3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar11);
export default __webpack_public_path__ + "static/media/avatar11.e4ad4f9f8fe08a99900e535b26f537f4.svg";
export { ForwardRef as ReactComponent };